export default "__VITE_ASSET__B46nr1MG__"